import styled, { css } from "styled-components"
import { RateItemProps, RateProps, RateSize, RateVariant } from "."

import Basic from '../../../assets/images/business/b_m_cnt13_basic.svg';
import Pro from '../../../assets/images/business/b_m_cnt13_pro.svg';
import Enterprise from '../../../assets/images/business/b_m_cnt13_ent.svg';

export const Title = styled.div<RateItemProps>`
  font-size: ${({isActive, size}) => size === RateSize.DEFAULT ? (isActive ? 26 : 20) : (isActive ? 20 : 14)}px;
  line-height: 40px;
  font-weight: 600;
  text-align: center;
  color: rgba(224, 224, 224, 1);
  height: 80px;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: ${({isActive, size}) => size === RateSize.DEFAULT ? (isActive ? 32 : 26) : (isActive ? 26 : 20)}px;
    line-height: 60px;
  }
`

export const Content = styled.div<RateItemProps>`
  display: flex;
  flex-direction: column;
  ${({isActive, size}) =>
    isActive
      ? css`
          gap: 10px;
          margin-top: 30px;
          margin-bottom: 30px;
        `
      : css`
          gap: 5px;
          margin-top: 10px;
          margin-bottom: 10px;
        `
  };

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    ${({isActive, size}) =>
      isActive
        ? css`
            gap: ${size === RateSize.DEFAULT ? 30 : 20}px;
            margin-top: ${size === RateSize.DEFAULT ? 30 : 20}px;
            margin-bottom: ${size === RateSize.DEFAULT ? 30 : 20}px;
          `
        : css`
            gap: 10px;
            margin-top: 10px;
            margin-bottom: 10px;
          `
    };
  }
`

export const Description = styled.div<RateItemProps>`
  padding: 0 20px;
  font-size: ${({isActive, size}) => size === RateSize.DEFAULT ? (isActive ? 16 : 14) : (isActive ? 14 : 12)}px;
  line-height: ${({size}) => size === RateSize.DEFAULT ? 25 : 20}px;
  font-weight: 400;
  text-align: center;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    padding: 0 50px;
    font-size: ${({isActive, size}) => size === RateSize.DEFAULT ? (isActive ? 20 : 16) : (isActive ? 16 : 13)}px;
    line-height: ${({size}) => size === RateSize.DEFAULT ? 30 : 20}px;
  }
`

export const Item = styled.div``

export const Value = styled.div<RateItemProps>`
  font-size: ${({isActive, size}) => size === RateSize.DEFAULT ? (isActive ? 22 : 18) : (isActive ? 18 : 16)}px;
  line-height: ${({isActive, size}) => size === RateSize.DEFAULT ? (isActive ? 36 : 30) : (isActive ? 30 : 25)}px;
  font-weight: 600;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: ${({isActive, size}) => size === RateSize.DEFAULT ? (isActive ? 32 : 24) : (isActive ? 24 : 20)}px;
    line-height: ${({isActive, size}) => size === RateSize.DEFAULT ? (isActive ? 40 : 38) : (isActive ? 35 : 30)}px;
  }
`

export const Text = styled.div<RateItemProps>`
  font-size: ${({isActive, size}) => size === RateSize.DEFAULT ? (isActive ? 16 : 14) : (isActive ? 18 : 16)}px;
  line-height: ${({size}) => size === RateSize.DEFAULT ? 30 : 20}px;
  font-weight: 400;
  color: rgba(21, 21, 21, 1);

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: ${({isActive, size}) => size === RateSize.DEFAULT ? (isActive ? 22 : 16) : (isActive ? 16 : 13)}px;
    line-height: ${({size}) => size === RateSize.DEFAULT ? 40 : 30}px;
  }
`

export const Footer = styled.div<RateItemProps>`
  padding: 0 50px 20px;;
`

export const Button = styled.button<RateItemProps>`
  width: 100%;
  border-radius: 40px;
  border: none;
  cursor: pointer;
  line-height: 33px;
  color: rgba(255, 255, 255, 1);
  ${({isActive, size}) =>
      isActive
          ? css`
            padding: 15px 0;
            font-size: ${size === RateSize.DEFAULT ? 20 : 15}px;
          `
          : css`
            padding: 10px 0;
            font-size: ${size === RateSize.DEFAULT ? 16 : 13}px;
          `
  };

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    ${({isActive, size}) =>
      isActive
          ? css`
            padding:${size === RateSize.DEFAULT ? '20px 0' : '10px 0'};
            font-size: ${size === RateSize.DEFAULT ? 24 : 18}px;
          `
          : css`
            width: ${size === RateSize.DEFAULT ? 100 : 80}%;
            padding:${size === RateSize.DEFAULT ? '15px 0' : '10px 0'};
            font-size: ${size === RateSize.DEFAULT ? 18 : 14}px;
          `
    };
  }
`

export const Rate = styled.div<RateProps>`
  border-radius: 40px;
  width: 100%;
  height: auto;
  text-align: center;

  ${({variant, theme}) => {
    const url = ({
      [RateVariant.BASE]: Basic,
      [RateVariant.PRO]: Pro,
      [RateVariant.ENTERPRISE]: Enterprise,
    })[variant];
    const color = ({
      [RateVariant.BASE]: theme.business.colors.tariffBase,
      [RateVariant.PRO]: theme.business.colors.tariffPro,
      [RateVariant.ENTERPRISE]: theme.business.colors.tariffEnterprise,
    })[variant];
    return css`
      background: url(${url}) no-repeat top #fff;
      color: ${color};

      & button {
        background: ${color};
      }
    `
  }
};
`